import React from "react";
import styled, { withTheme } from "styled-components/native";
import { Route, withRouter } from "cci-utility";
import Button from "../button/Button";
import WidePlaceholder from "./WidePlaceholder";

const Wrapper = styled.View`
  flex-direction: row;
  align-items: stretch;
  flex: 1;
`;

/**
 * Shows a component on the left and another on the right when on a wide screen, when narrow either the left or right use up the entire screen.
 * This is set using the match prop and the isNarrow state, for example, in this way:
 * 
 * match.isExact    isNarrow    result
 *  true            true        LEFT COMPONENT
 *  true            false       LEFT COMPONENT & PLACEHOLDER
 *  false           true        RIGHT COMPONENT
 *  false           false       LEFT & RIGHT COMPONENTS
 * 
 * Props:
 * - rootPath: Router URL path that the user must navigate to in order to show the component.
 * - left: Left component that must be shown when the at the rootPath.
 * - selectionPath: Router URL path user must navigate to show the right side component.
 * - placeholder: Placeholder component that must be shown when on a wide screen and a selection has not been made.
 * - placeholderMessage: Localization object or string that will be shown in the default placeholder.
 * - right: Right side component that must he shown when at the selectionPath.
 * - leftRightOptions: Props that must be passed down to both the left and right components.
 * - hideLeftButton: Boolean Prop that means to show or hide the "Hide Left Button". This button allows to hide the Left component ONLY on widescreen (isNarrow=false).
 */
//TODO This component should support recursive paths, an example of this is: https://reacttraining.com/react-router/web/example/recursive-paths
class WideSplitView extends React.Component {
  constructor() {
    super();

    this.state = { isNarrow: false, hideLeft: false };
    this.onLayout = this.onLayout.bind(this);
  }

  onLayout(e) {
    const isNarrow = e.nativeEvent.layout.width < 768;

    if (this.state.isNarrow !== isNarrow) {
      this.setState({ isNarrow });
    }
  }

  render() {
    const {
        theme,
        rootPath,
        selectionPath,
        left: Left,
        right: Right,
        placeholder: Placeholder,
        placeholderMessage,
        leftRightOptions,
        leftOptions,
        rightOptions,
        hideLeftButton,
        match
      } = this.props,
      { isNarrow, hideLeft } = this.state,
      rightRoute = () => <Route
        exact
        path={selectionPath}
        render={() => <Right
          rootPath={rootPath}
          {...leftRightOptions}
          {...rightOptions}
        />}
      />;

    return (
      <Wrapper onLayout={this.onLayout}>
        {/* Left component */}
        <Route
          path={rootPath}
          children={routeProps => (
            <Left
              // Since the Left component is dynamic, we can't used styled-components here
              style={{
                width: theme.sidebarWidth,
                borderRightColor: theme.fontColor,
                borderStyle: "solid",
                borderRightWidth: isNarrow ? 0 : 1,
                flex: isNarrow || hideLeft ? (match.isExact ? 1 : 0) : null,
                display: isNarrow || hideLeft ? (match.isExact ? 'flex' : 'none') : 'flex'
              }}

              {...routeProps}
              {...leftRightOptions}
              {...leftOptions}
            />
          )}
        />

        {/* Placeholder component giving instructions to the user */}
        {!isNarrow && match.isExact && <Route
          exact
          path={rootPath}
          render={() => <Placeholder message={placeholderMessage} />}
        />}

        {/* Right side component shown when a selection is made on the left component */}
        {rightRoute()}

        {/* HIDE LEFT BUTTON */}
        {!isNarrow && !match.isExact && hideLeftButton && <Button
          onPress={() => this.setState({ hideLeft: !hideLeft })}
          iconSize={12}
          leftIcon={hideLeft ? "chevron-right" : "chevron-left"}
          paddings="5px"
          style={{
            position: 'absolute',
            left: hideLeft ? theme.pagePadding : theme.sidebarWidth - 10,
            top: theme.pageContentMarginTop + 5,
            width: 20,
            height: 20,
            backgroundColor: theme.fontColor
          }}
        />}
      </Wrapper>
    );
  }
}

WideSplitView.defaultProps = {
  placeholder: WidePlaceholder
};

export default withTheme(withRouter(WideSplitView));
